import React from 'react';
import { 
  AlertTriangle, PieChart as PieChartIcon, Target, ShieldCheck, Users, Sparkles, 
  Zap, Thermometer, List, School, HeartPulse, Compass, 
  Download, Loader2, Brain, Activity
} from 'lucide-react';

import EditableAIBox from '../EditableAIBox';

// --- 1. BİREYSEL RAPOR ARAYÜZÜ ---
export const DevamsizlikReportUI = ({ data, meta }) => {
  const risks = data.risks || [];

  const guessCategory = (text) => {
    const lower = text.toLowerCase();
    if (lower.match(/aile|anne|baba|ev|kardeş|maddi|çalışmak|iş|para|bakmak/)) return "Aile ve Çevre";
    if (lower.match(/okul|öğretmen|ders|arkadaş|zorba|sınav|not|müdür|disiplin|kavga/)) return "Okul ve Uyum";
    if (lower.match(/sağlık|hastalık|uyku|kaza|beden|rahatsız/)) return "Sağlık Durumu";
    if (lower.match(/ilgi|istek|motivasyon|sıkıcı|hedef|korku|can sık/)) return "Kişisel Motivasyon";
    return "Genel Nedenler";
  };

  const categories = {};
  risks.forEach(r => {
    const text = typeof r === 'object' ? r.text : r;
    let catName = (typeof r === 'object' && r.category) ? r.category : "";
    
    if (!catName || catName === "Baskın Neden" || catName === "Diğer Nedenler" || catName === "Genel") {
        catName = guessCategory(text);
    }
    
    if (!categories[catName]) categories[catName] = { count: 0, percent: 0, meta: { color: "#3b82f6" } };
    categories[catName].count += 1;
  });

  const colors = ["#f59e0b", "#3b82f6", "#ef4444", "#10b981", "#8b5cf6", "#ec4899"];
  Object.keys(categories).forEach((key, i) => {
    categories[key].percent = risks.length > 0 ? Math.round((categories[key].count / risks.length) * 100) : 0;
    categories[key].meta.color = colors[i % colors.length];
  });

  const sortedCats = Object.entries(categories).sort((a, b) => b[1].percent - a[1].percent);
  const topCategoryName = sortedCats.length > 0 ? sortedCats[0][0] : "Genel Nedenler";

  

  const criticalRisks = [];
  const allRisksFormatted = [];
  
  let chronicCount = 0;
  let acuteCount = 0;

  risks.forEach(r => {
    const text = typeof r === 'object' ? r.text : r;
    let category = typeof r === 'object' && r.category ? r.category : "";
    if (!category || category === "Baskın Neden" || category === "Diğer Nedenler" || category === "Genel") {
        category = guessCategory(text);
    }

    const id = typeof r === 'object' ? r.id : "-";
    // 🚀 SİHİRLİ DOKUNUŞ: Motorun eklediği "⚠️ [KRİTİK]" ve "(Puan: X)" kısımlarını vitrinden siliyoruz
    const cleanText = text.replace(/⚠️\s*\[KRİTİK\]\s*/g, "").replace(/\s*\(Puan:\s*\d+\)/g, "").trim();
    // 🚀 SİHİRLİ DOKUNUŞ: Artık kelime avına çıkmıyoruz! 
    // Direkt Evrensel Motorun hesapladığı 'severity' (şiddet) etiketine bakıyoruz.
    const isCritical = typeof r === 'object' && r.severity === 'critical';
    
    const riskItem = { id, text: cleanText, category, isCritical };
    if (isCritical) criticalRisks.push(riskItem);
    allRisksFormatted.push(riskItem);

    const lower = cleanText.toLowerCase();
    if (lower.match(/ilgi|istek|motivasyon|sıkıcı|hedef|okul|öğretmen|ders|not|başarısız/)) {
        chronicCount++;
    } else if (lower.match(/sağlık|hastalık|kaza|uyku|kavga|ceza|ani|maddi|para|çalışmak/)) {
        acuteCount++;
    } else {
        chronicCount += 0.5;
    }
  });

 let typology = { title: "Dengeli Profil", desc: "Öğrencinin devamsızlık nedenleri belirgin bir odakta toplanmamış veya yeterli veri bulunmamaktadır.", color: "text-slate-700", bg: "bg-slate-50", border: "border-slate-200", iconCol: "text-slate-500" };
  let actionKey = "Genel Nedenler"; // Çözüm havuzu için eşleştirme anahtarı
  
  // 🚀 SİHİRLİ DOKUNUŞ: Artık Evrensel Motordan gelen Büyük Harfli ve Eğik çizgili (Okul/Yönetim) isimleri doğru yakalıyoruz!
  const topUpper = topCategoryName.toUpperCase();
  
  if (topUpper.includes('OKUL') || topUpper.includes('ÖĞRETMEN') || topUpper.includes('YÖNETİM') || topUpper.includes('YONETIM') || topUpper.includes('AKRAN')) {
      typology = { title: "Okul Reddi / Kaygılı Kaçınan", desc: "Öğrenci; okul iklimi, idari faktörler veya akran/öğretmen ilişkileri kaynaklı sorunlar nedeniyle okuldan uzaklaşmaktadır.", color: "text-indigo-800", bg: "bg-indigo-50", border: "border-indigo-200", iconCol: "text-indigo-600" };
      actionKey = "Okul ve Uyum";
  } else if (topUpper.includes('KİŞİSEL') || topUpper.includes('KISISEL') || topUpper.includes('AKADEMİK') || topUpper.includes('AKADEMIK') || topUpper.includes('MOTİVASYON')) {
      typology = { title: "Sisteme Yabancılaşmış", desc: "Öğrencinin okula karşı ilgisi azalmış, akademik hedefleri belirsizleşmiş ve içsel motivasyonu tükenme noktasına gelmiştir.", color: "text-orange-800", bg: "bg-orange-50", border: "border-orange-200", iconCol: "text-orange-600" };
      actionKey = "Kişisel Motivasyon";
  } else if (topUpper.includes('AİLE') || topUpper.includes('AILE') || topUpper.includes('ÇEVRE') || topUpper.includes('CEVRE')) {
      typology = { title: "Zorunlu Uzaklaşan (Çevresel)", desc: "Öğrenci kendi iradesi dışında; ailevi sorunlar, ev içi sorumluluklar veya dış çevresel zorluklar nedeniyle okuldan kopmaktadır.", color: "text-rose-800", bg: "bg-rose-50", border: "border-rose-200", iconCol: "text-rose-600" };
      actionKey = "Aile ve Çevre";
  } else if (topUpper.includes('SAĞLIK') || topUpper.includes('BEDEN')) {
      typology = { title: "Zorunlu Uzaklaşan (Fiziksel)", desc: "Öğrencinin devamsızlığı ağırlıklı olarak bedensel rahatsızlıklar, uyku sorunları veya kronik sağlık şikayetlerine dayanmaktadır.", color: "text-teal-800", bg: "bg-teal-50", border: "border-teal-200", iconCol: "text-teal-600" };
      actionKey = "Sağlık Durumu";
  }

  const actionPool = {
    "Okul ve Uyum": [
        "İlk gördüğünüzde 'Neden gelmiyorsun?' demek yerine, okuldaki varlığının fark edildiğini hissettiren küçük, pozitif bir sorumluluk verin.",
        "Döndüğü ilk gün tahtaya kalkma vb. stres yaratıcı durumlardan muaf tutulmasını sınıf öğretmeniyle sessizce koordine edin."
    ],
    "Kişisel Motivasyon": [
        "İlk 24 saat içinde öğrenciyle sadece sevdiği bir hobi veya ilgi alanı hakkında 10 dakikalık, baskısız bir sohbet yapın.",
        "Devamsızlık hakkında konuşmadan, onun fikirlerine değer verdiğinizi hissettirecek kısa bir 'nasılsın' teması kurun."
    ],
    "Aile ve Çevre": [
        "Aileyi yargılamadan, 'Öğrencimizi özledik, nasıl destek olabiliriz?' diyerek empatik ve destekleyici bir ilk telefon görüşmesi planlayın.",
        "Öğrenciye sorular sormadan önce, okulda fiziksel veya temel bir ihtiyacı olup olmadığını sessizce gözlemleyin."
    ],
    "Sağlık Durumu": [
        "Öğrencinin sağlık sürecini yakından takip ettiğinizi hissettiren bir 'geçmiş olsun' mesajı iletin.",
        "Bedensel olarak zorlanmayacağı bir oturma düzeni veya telafi planı için sınıf öğretmeniyle iletişime geçin."
    ],
    "Genel Nedenler": [
        "Öğrenciyi okulda gördüğünüz ilk an sadece gülümseyin ve 'Seni burada görmek çok güzel' diyerek varlığını şartsız onaylayın."
    ]
  };

 const studentSeed = risks.length + (meta?.studentNo ? String(meta.studentNo).charCodeAt(0) : 0);
  // Eski hali: actionPool[topCategoryName] idi. Yeni hali şu olmalı:
  const selectedActions = actionPool[actionKey] || actionPool["Genel Nedenler"]; 
  const microActionText = selectedActions[studentSeed % selectedActions.length];

  const isChronic = chronicCount >= acuteCount && risks.length > 0;
  const chronicityTitle = isChronic ? "Kronikleşme / Kopuş Eğilimi" : "Akut / Durumsal Kriz";
  const chronicityDesc = isChronic 
    ? "Öğrencinin okulla duygusal bağı zayıflamış ve kronik bir kopuş sürecine girmiş olma ihtimali yüksektir." 
    : "Devamsızlığın kökeninde ağırlıklı olarak anlık, durumsal veya dışsal kriz faktörleri yatmaktadır.";
  const chronicityNote = isChronic
    ? "Müdahale Notu: Sistematik bir okula yeniden kazanma projesi gerekir."
    : "Müdahale Notu: Sorun henüz taze. Hızlı bir görüşmeyle bağ kurulabilir.";
  const chronicityCol = isChronic ? "text-rose-700" : "text-amber-600";
  const chronicityBg = isChronic ? "bg-rose-50" : "bg-amber-50";
  const chronicityBorder = isChronic ? "border-rose-100" : "border-amber-100";
  // 🚀 SİHİRLİ DOKUNUŞ: Ekran artık kendi kafasına göre değil, EVRENSEL MOTOR'un kararına (riskLevel) göre alarm veriyor!
  const isRedAlarm = data.riskLevel === "high";
  const isHighVolume = allRisksFormatted.length > 14;
  return (
    <div className="space-y-6 print:space-y-4 font-sans flex flex-col print:min-h-[260mm]">
      
      <div className={`p-4 print:p-3 rounded-xl flex justify-between items-center shadow-sm print:bg-white print:text-black print:shadow-none print:border-b-2 print:border-slate-900 ${isRedAlarm ? 'bg-red-900 text-white' : 'bg-slate-900 text-white'}`}>
        <div className="flex items-center gap-4 print:gap-3">
          <div className={`h-12 w-12 print:h-9 print:w-9 rounded-xl flex items-center justify-center shadow-inner ${isRedAlarm ? 'bg-red-600' : 'bg-slate-700'}`}>
            <AlertTriangle className="h-6 w-6 print:h-4 print:w-4"/>
          </div>
          <div>
            <h2 className="text-xl print:text-lg font-bold leading-none mb-1">Devamsızlık Nedenleri Analizi</h2>
            <span className="text-[10px] print:text-[10px] text-slate-300 print:text-slate-600 font-bold tracking-widest uppercase block">
               {meta?.studentClass || "Sınıf Belirtilmemiş"} • ÖĞRENCİ NO: {meta?.studentNo || "-"}
            </span>
          </div>
        </div>
        <div className="bg-white/10 px-4 py-2 print:px-3 print:py-1.5 rounded-lg text-center print:border print:border-slate-300">
          <span className={`text-2xl print:text-xl font-black block leading-none ${isRedAlarm ? 'text-red-300' : 'text-slate-200'}`}>{risks.length}</span>
          <span className="text-[9px] print:text-[9px] block opacity-70 uppercase font-bold mt-0.5">Madde</span>
        </div>
      </div>

      <div className="grid grid-cols-1 md:grid-cols-2 print:grid-cols-2 gap-4 print:gap-4">
         <div className="bg-white p-5 print:p-4 rounded-2xl border border-slate-200 shadow-sm flex flex-col justify-center print:border-slate-300">
           <h3 className="font-bold text-slate-800 mb-4 print:mb-2.5 flex items-center text-sm print:text-[11px] border-b pb-2 print:pb-1.5">
               <PieChartIcon className="h-4 w-4 print:h-3.5 print:w-3.5 mr-2 text-blue-600"/> Ana Neden Dağılımı
           </h3>
           <div className="space-y-4 print:space-y-2 flex-1 flex flex-col justify-center">
             {sortedCats.length > 0 ? sortedCats.map(([name, details]) => (
               <div key={name}>
                 <div className="flex justify-between items-end mb-1 print:mb-0.5">
                   <span className="text-[10px] print:text-[8px] font-bold text-slate-500 uppercase tracking-wide">{name}</span>
                   <span className="text-xs print:text-[9px] font-black text-slate-800">%{details.percent}</span>
                 </div>
                 <div className="h-2 print:h-1.5 w-full bg-slate-100 rounded-full overflow-hidden print:border print:border-slate-300">
                   <div className="h-full rounded-full print:bg-slate-700" style={{ width: `${details.percent}%`, backgroundColor: details.meta?.color || '#3b82f6' }}></div>
                 </div>
               </div>
             )) : <p className="text-xs text-slate-400 italic">Veri bulunamadı.</p>}
           </div>
         </div>

         <div className={`${typology.bg} p-5 print:p-4 rounded-2xl border ${typology.border} print:bg-white print:border-slate-300 flex flex-col justify-center shadow-sm relative overflow-hidden`}>
           <div className={`flex items-center mb-3 print:mb-2 border-b ${typology.border} pb-2 print:pb-1.5 opacity-90 print:border-slate-200`}>
             <Target className={`h-5 w-5 print:h-4 print:w-4 mr-2 ${typology.iconCol}`}/>
             <span className={`text-xs print:text-[10.5px] font-black uppercase tracking-widest ${typology.color}`}>Devamsızlık Tipolojisi</span>
           </div>
           
           <h3 className={`text-lg print:text-[13px] font-black mb-1.5 print:mb-1 mt-1 leading-tight ${typology.color}`}>
             {typology.title}
           </h3>
           <p className="text-[11px] print:text-[10px] text-slate-700 leading-snug font-medium mb-3 print:mb-2 text-justify">
             {typology.desc}
           </p>

           {criticalRisks.length > 0 && (
             <div className="mt-auto bg-red-100/80 border border-red-200 p-2 print:p-1.5 rounded-lg flex items-center shadow-sm">
               <AlertTriangle className="h-4 w-4 print:h-3 print:w-3 text-red-600 mr-2 animate-pulse"/>
               <span className="text-[10px] print:text-[8px] font-bold text-red-800 leading-tight uppercase tracking-wide">Acil: Kırmızı alarm veren riskler tespit edildi!</span>
             </div>
           )}
         </div>
      </div>

      <div className="grid grid-cols-1 md:grid-cols-2 print:grid-cols-2 gap-4 print:gap-4">
          <div className="bg-sky-50 p-5 print:p-4 rounded-2xl border border-sky-100 shadow-sm flex flex-col justify-center print:bg-white print:border-slate-300">
            <div className="flex items-center mb-1">
              <Zap className="h-5 w-5 print:h-4 print:w-4 text-sky-600 mr-2"/>
              <span className="text-xs print:text-[10px] font-black uppercase tracking-widest text-sky-900">Çözüm Odaklı İlk Adım</span>
            </div>
            <h4 className="text-sm print:text-[11.5px] font-black text-sky-800 mb-1.5 mt-1">(İlk 24 Saat Müdahalesi)</h4>
            <p className="text-[13px] print:text-[9.5px] font-medium text-sky-900 leading-snug text-justify">
              {microActionText}
            </p>
          </div>

          <div className={`${chronicityBg} p-5 print:p-4 rounded-2xl border ${chronicityBorder} shadow-sm flex flex-col justify-center print:bg-white print:border-slate-300`}>
            <div className="flex items-center mb-1">
              <Thermometer className={`h-5 w-5 print:h-4 print:w-4 ${chronicityCol} mr-2`}/>
              <span className={`text-xs print:text-[10px] font-black uppercase tracking-widest ${chronicityCol}`}>Derinlik Göstergesi</span>
            </div>
            <h4 className={`text-sm print:text-[11.5px] font-black mb-1.5 mt-1 ${chronicityCol}`}>{chronicityTitle}</h4>
            <p className="text-[13px] print:text-[9.5px] text-slate-700 font-medium leading-snug mb-1 text-justify">
              {chronicityDesc}
            </p>
            <p className={`text-[10px] print:text-[8.5px] font-bold ${chronicityCol}`}>
              {chronicityNote}
            </p>
          </div>
      </div>

      <div className="bg-slate-50 p-5 print:p-4 rounded-2xl border border-slate-200 print:bg-white print:border-t-2 print:border-slate-900 print:rounded-none print:shadow-none flex-1 mt-2">
        <h3 className="font-bold text-slate-800 mb-4 print:mb-3 flex items-center text-sm print:text-[11px] border-b pb-3 print:pb-2">
          <List className="h-4 w-4 mr-2 text-slate-500"/> Tüm İşaretlenen Nedenler ({allRisksFormatted.length})
        </h3>
        
        {allRisksFormatted.length > 0 ? (
          <div className={`grid grid-cols-1 md:grid-cols-2 ${isHighVolume ? 'print:grid-cols-3 print:gap-1.5' : 'print:grid-cols-2 print:gap-2.5'} gap-3`}>
            {allRisksFormatted.map((item, i) => (
              <div key={i} className={`flex items-start p-3 ${isHighVolume ? 'print:p-1.5' : 'print:p-2'} bg-white border rounded-xl print:rounded-lg shadow-sm transition-colors ${item.isCritical ? 'border-red-200 bg-red-50/30' : 'border-slate-200'}`}>
                <div className={`min-w-[24px] h-6 ${isHighVolume ? 'print:min-w-[14px] print:h-3.5 print:text-[7px]' : 'print:min-w-[18px] print:h-4.5 print:text-[8px]'} rounded flex items-center justify-center text-[10px] font-black mr-3 ${isHighVolume ? 'print:mr-1.5' : 'print:mr-2'} border ${item.isCritical ? 'bg-red-100 text-red-700 border-red-200' : 'bg-slate-100 text-slate-600 border-slate-200'}`}>
                  {item.id}
                </div>
                <div className="flex-1">
                  <div className="flex justify-between items-center mb-1 print:mb-[1px]">
                    <span className={`block text-[8px] ${isHighVolume ? 'print:text-[6.5px]' : 'print:text-[7.5px]'} font-bold text-slate-400 uppercase tracking-wider`}>{item.category}</span>
                    {item.isCritical && <span className={`text-[8px] ${isHighVolume ? 'print:text-[6px] px-1 py-[1px]' : 'print:text-[7px] px-1.5 py-0.5'} bg-red-100 text-red-700 rounded font-black tracking-widest uppercase shadow-sm`}>Kritik</span>}
                  </div>
                  <span className={`text-[11px] ${isHighVolume ? 'print:text-[8px] leading-tight' : 'print:text-[9.5px] leading-snug'} text-slate-800 font-medium block`}>{item.text}</span>
                </div>
              </div>
            ))}
          </div>
        ) : (
          <p className="text-xs text-slate-400 italic text-center py-4 print:py-2">İşaretlenmiş madde bulunmamaktadır.</p>
        )}
      </div>
    </div>
  );
};

// --- 2. KURUMSAL (TOPLU) HESAPLAMA MOTORU ---
export const aggregateDevamsizlik = (subs) => {
  const total = subs.length;
  if (total === 0) return null;

  const guessCategory = (text) => {
    const lower = text.toLowerCase();
    if (lower.match(/aile|anne|baba|ev|kardeş|maddi|çalışmak|iş|para|bakmak/)) return "Aile ve Çevre";
    if (lower.match(/okul|öğretmen|ders|arkadaş|zorba|sınav|not|müdür|disiplin|kavga/)) return "Okul ve Uyum";
    if (lower.match(/sağlık|hastalık|uyku|kaza|beden|rahatsız/)) return "Sağlık Durumu";
    if (lower.match(/ilgi|istek|motivasyon|sıkıcı|hedef|korku|can sık/)) return "Kişisel Motivasyon";
    return "Genel Nedenler";
  };

  let redAlarmStudents = 0;
  let totalRisksCount = 0;
  let chronicCount = 0; 
  let acuteCount = 0; 

  const categoryMap = {};
  const classMap = {};
  const itemMap = {}; 

  subs.forEach(s => {
    const className = s.studentClass || s.sinif || s.sınıf || s.class || s.grade || s.studentInfo?.sinif || "Tüm Sınıflar";
    if (!classMap[className]) {
      classMap[className] = { name: className, studentCount: 0, riskCount: 0 };
    }
    classMap[className].studentCount++;

    const risks = s.reportData?.risks || [];
    totalRisksCount += risks.length;
    classMap[className].riskCount += risks.length;

    // 🚀 SİHİRLİ DOKUNUŞ: Kurumsal motor da öğrencinin kırmızı alarmda olup olmadığını Evrensel Motor'un (riskLevel) verisinden anlıyor.
    if (s.reportData?.riskLevel === "high") {
        redAlarmStudents++;
    }

    risks.forEach(r => {
      const text = typeof r === 'object' ? r.text : r;
      // 🚀 SİHİRLİ DOKUNUŞ: Kurumsal listede de Puan ve Kritik yazılarını siliyoruz
      const cleanText = text.replace(/⚠️\s*\[KRİTİK\]\s*/g, "").replace(/\s*\(Puan:\s*\d+\)/g, "").trim();
      let cat = typeof r === 'object' && r.category ? r.category : "";
      
      if (!cat || cat.includes("Baskın Neden") || cat === "Diğer Nedenler" || cat === "Genel") {
          cat = guessCategory(cleanText);
      }

      if (!categoryMap[cat]) categoryMap[cat] = 0;
      categoryMap[cat]++;

      const id = typeof r === 'object' ? r.id : cleanText;
      if (!itemMap[id]) itemMap[id] = { id, text: cleanText, count: 0, category: cat };
      itemMap[id].count++;

      const lower = cleanText.toLowerCase();
      if (lower.match(/ilgi|istek|motivasyon|sıkıcı|hedef|okul|öğretmen|ders|not|başarısız/)) {
          chronicCount++;
      } else if (lower.match(/sağlık|hastalık|kaza|uyku|kavga|ceza|ani|maddi|para|çalışmak/)) {
          acuteCount++;
      } else {
          chronicCount += 0.5;
      }
    });
  });

  const avgRisksPerStudent = total > 0 ? (totalRisksCount / total).toFixed(1) : 0;
  const totalDepth = chronicCount + acuteCount || 1;
  const chronicPercent = Math.round((chronicCount / totalDepth) * 100);
  const acutePercent = 100 - chronicPercent;

  const topCategories = Object.entries(categoryMap)
    .map(([name, count]) => ({ name, count, percent: Math.round((count / totalRisksCount) * 100) }))
    .sort((a, b) => b.count - a.count);

  const dominantCategory = topCategories.length > 0 ? topCategories[0] : { name: 'Genel Nedenler', percent: 0 };

  const classStats = Object.values(classMap).map(c => ({
    ...c,
    riskScore: c.studentCount > 0 ? (c.riskCount / c.studentCount).toFixed(1) : 0
  })).sort((a, b) => b.riskScore - a.riskScore);

  const top10Items = Object.values(itemMap)
    .map(i => ({ ...i, percent: Math.round((i.count / total) * 100) }))
    .sort((a, b) => b.count - a.count)
    .slice(0, 10);

  return { total, redAlarmStudents, avgRisksPerStudent, chronicPercent, acutePercent, topCategories, dominantCategory, classStats, top10Items };
};


// --- 3. KURUMSAL RAPOR ARAYÜZÜ ---
export const DevamsizlikKurumsalUI = ({ title, subs, aiResult, onGenerateAI, aiLoading, handlePrint, downloading }) => {
  const data = aggregateDevamsizlik(subs);
  if (!data) return <div className="p-8 text-center text-slate-500">Bu gruba ait veri bulunamadı.</div>;

  const isRedAlarm = data.redAlarmStudents > 0;
  const redAlarmPercent = data.total > 0 ? Math.round((data.redAlarmStudents / data.total) * 100) : 0;

  let chronicityText = "";
  if (data.chronicPercent > 65) {
      chronicityText = "Kurumdaki devamsızlıkların kökeninde 'okula yabancılaşma' ve 'kronik motivasyon kaybı' yatmaktadır. Öğrencilerin okulla olan duygusal bağı zayıflamış ve kopuş süreci başlamıştır.";
  } else if (data.acutePercent > 65) {
      chronicityText = "Kurumdaki devamsızlıklar ağırlıklı olarak anlık, durumsal veya dışsal (sağlık, maddi kriz, ailevi olaylar) faktörlerden kaynaklanmaktadır. Hızlı müdahale ile kolayca geri kazanılabilirler.";
  } else {
      chronicityText = "Kurumdaki devamsızlıklar kronik isteksizlik ve durumsal krizler arasında dengeli bir dağılım göstermektedir. Hem genel iklim çalışmaları hem de bireysel kriz yönetimi gereklidir.";
  }

  let interventionObj = {};
  let stakeholderObj = {};

  if (data.dominantCategory.name === "Okul ve Uyum") {
      interventionObj = {
          title: "Okul İklimi ve Aidiyet Müdahalesi",
          icon: School, color: "text-indigo-700", bg: "bg-indigo-50 print:bg-white border-indigo-200 print:border-slate-300",
          desc: "Öğrenciler okul ortamını (akranlar veya öğretmenler) stres verici bulduğu için okuldan kaçınmaktadır.",
          bullets: [
              "Okulda 'Akran Zorbalığını Önleme' ve güvenli okul iklimi kampanyaları başlatılmalıdır.",
              "Devamsızlık yapan öğrencilerin okul içindeki sosyal rolleri (görev/sorumluluk) artırılmalıdır.",
              "Sınıf içi gruplaşmalar PDR servisi tarafından Sosyometri uygulanarak analiz edilmelidir."
          ]
      };
      stakeholderObj = {
          title: "Öğretmen ve İdare Stratejisi",
          icon: ShieldCheck, color: "text-blue-700", bg: "bg-blue-50 print:bg-white border-blue-200 print:border-slate-300",
          desc: "Okul kuralları ve öğretmen tutumları, öğrenciyi uzaklaştıran değil kucaklayan bir tonda olmalıdır.",
          bullets: [
              "Öğretmenler: Öğrenci okula döndüğünde 'Neredeydin?' yerine 'Seni görmek güzel' dili kullanmalıdır.",
              "İdare: Disiplin süreçlerinde cezalandırıcı değil, okulda tutmaya yönelik esnek çözümler aramalıdır.",
              "Veli İletişimi: Okulun öğrenci için güvenli ve destekleyici bir alan olduğu veliye hissettirilmelidir."
          ]
      };
  } else if (data.dominantCategory.name === "Kişisel Motivasyon") {
      interventionObj = {
          title: "Akademik Bağlanma ve Hedef Odaklılık",
          icon: Target, color: "text-orange-700", bg: "bg-orange-50 print:bg-white border-orange-200 print:border-slate-300",
          desc: "Öğrenciler 'okula gelmenin anlamını ve amacını' yitirmiş durumdadır. Sisteme yabancılaşma mevcuttur.",
          bullets: [
              "Kariyer günleri, meslek tanıtımları ve üniversite gezileri ile hedefsizlik kırılmalıdır.",
              "Öğrencilerin sadece notla değil, ilgi alanlarıyla da (spor, sanat, kulüp) değerlendirildiği alanlar açılmalıdır.",
              "Başarısızlık hissi yaşayan öğrenciler için PDR servisinde 'Akademik Özgüven' çalışmaları yapılmalıdır."
          ]
      };
      stakeholderObj = {
          title: "Sınıf İçi İlgi Çekme",
          icon: Zap, color: "text-amber-700", bg: "bg-amber-50 print:bg-white border-amber-200 print:border-slate-300",
          desc: "Eğitim sürecinin monotonluğu kırılmalı, öğrencinin derse olan ilgisi yeniden canlandırılmalıdır.",
          bullets: [
              "Öğretmenler: Ders içeriklerini günlük hayatla ve öğrencinin ilgi alanlarıyla ilişkilendirmelidir.",
              "Sınıf Rehberliği: 'Gelecekteki Ben' vizyonu oluşturacak küçük sınıf etkinlikleri planlanmalıdır.",
              "İdare: Öğrenci kulüplerini ve ders dışı faaliyetleri daha aktif hale getirmelidir."
          ]
      };
  } else if (data.dominantCategory.name === "Aile ve Çevre") {
      interventionObj = {
          title: "Sistemik Veli İşbirliği",
          icon: Users, color: "text-rose-700", bg: "bg-rose-50 print:bg-white border-rose-200 print:border-slate-300",
          desc: "Öğrenci okula gelmek istese de ailevi sorumluluklar, maddi krizler veya evdeki düzensizlik buna engel olmaktadır.",
          bullets: [
              "Veli görüşmeleri acilen başlatılmalı, devamsızlığın hukuki ve akademik sonuçları hatırlatılmalıdır.",
              "Öğrencinin çalışmak zorunda kaldığı veya kardeşe baktığı durumlar için aile ile alternatif plan yapılmalıdır.",
              "Ekonomik zorluk çeken öğrenciler tespit edilip, rehberlik servisi aracılığıyla destek mekanizmalarına yönlendirilmelidir."
          ]
      };
      stakeholderObj = {
          title: "Koruyucu ve Destekleyici Tutum",
          icon: HeartPulse, color: "text-pink-700", bg: "bg-pink-50 print:bg-white border-pink-200 print:border-slate-300",
          desc: "Evde dezavantajlı olan öğrenci için okul, yargılamayan ve şefkatli bir 'güvenli liman' olmalıdır.",
          bullets: [
              "Öğretmenler: Ödev veya materyal eksikliklerinde öğrencinin ev durumunu göz önünde bulundurarak esneklik sağlamalıdır.",
              "PDR Odak: Öğrenci ile psikolojik sağlamlık ve krizle baş etme becerileri üzerine çalışılmalıdır.",
              "İdare: Gerekli durumlarda okul-aile birliği üzerinden destek paketleri oluşturmalıdır."
          ]
      };
  } else {
      interventionObj = {
          title: "Durumsal Kriz Yönetimi (Sağlık/Genel)",
          icon: Thermometer, color: "text-teal-700", bg: "bg-teal-50 print:bg-white border-teal-200 print:border-slate-300",
          desc: "Devamsızlıkların temelinde kronik/akut sağlık sorunları, uyku düzeni eksikliği veya dönemsel hastalıklar yatmaktadır.",
          bullets: [
              "Sağlık raporları ve kronik rahatsızlıklar idare ve PDR servisi tarafından tek bir havuzda takip edilmelidir.",
              "Velilere 'Ergenlikte Uyku Düzeni ve Ekran Süresi' konulu dijital broşürler iletilmelidir.",
              "Uzun süreli hasta öğrencilerin okula dönüş süreçlerinde 'Akademik Telafi ve Uyum' desteği verilmelidir."
          ]
      };
      stakeholderObj = {
          title: "Sağlık ve Telafi Koordinasyonu",
          icon: Compass, color: "text-emerald-700", bg: "bg-emerald-50 print:bg-white border-emerald-200 print:border-slate-300",
          desc: "Öğrencinin bedensel zorlukları sebebiyle yaşadığı akademik kopuş, destekleyici sistemlerle engellenmelidir.",
          bullets: [
              "Öğretmenler: Hastalıktan dönen öğrenciyi sınav ve ödev baskısıyla bunaltmamalı, yumuşak bir geçiş sağlamalıdır.",
              "Veli İletişimi: Sağlık sürecinin okul ile şeffaf bir şekilde paylaşılması talep edilmelidir.",
              "Sınıf Rehberliği: Kronik rahatsızlığı olan öğrenciler için sınıfta duyarlılık ve empati kültürü oluşturulmalıdır."
          ]
      };
  }

  return (
    <>
      <div className="flex justify-end mb-4 no-print px-2">
         <button onClick={() => handlePrint('devamsizlik-kurumsal-area')} disabled={downloading} className="bg-blue-600 text-white px-5 py-2.5 rounded-xl font-bold flex items-center text-sm shadow-md hover:bg-blue-700 transition">
            {downloading ? <Loader2 className="animate-spin h-5 w-5 mr-2"/> : <Download className="h-5 w-5 mr-2"/>} Raporu Yazdır / PDF
         </button>
      </div>

      <div id="devamsizlik-kurumsal-area" className="font-sans flex flex-col bg-white print:bg-white">
        
        {/* ========================================================= */}
        {/* SAYFA 1: DERGİ KAPAĞI - YÖNETİCİ ÖZETİ VİTRİNİ            */}
        {/* ========================================================= */}
        <div className="flex flex-col gap-5 print:gap-3 mb-6 print:mb-0">
          
          <div className={`p-5 print:p-3 rounded-2xl flex justify-between items-center shadow-sm print:shadow-none print:border-b-2 print:border-slate-900 ${isRedAlarm ? 'bg-red-900 text-white' : 'bg-slate-900 text-white'} shrink-0 avoid-break`}>
            <div className="flex items-center gap-5 print:gap-3">
              <div className={`h-14 w-14 print:h-10 print:w-10 rounded-xl flex items-center justify-center shadow-inner ${isRedAlarm ? 'bg-red-600' : 'bg-slate-700'}`}>
                <Activity className="h-7 w-7 print:h-5 print:w-5"/>
              </div>
              <div>
                <h2 className="text-2xl print:text-lg font-black leading-none mb-1">{title}</h2>
                <span className="text-xs print:text-[10px] text-slate-300 print:text-slate-600 font-bold tracking-widest uppercase block">
                   DEVAMSIZLIK NEDENLERİ • KURUMSAL RİSK HARİTASI
                </span>
              </div>
            </div>
            <div className="bg-white/10 px-5 py-2.5 print:px-3 print:py-1.5 rounded-xl text-center print:border print:border-slate-300">
              <span className={`text-3xl print:text-xl font-black block leading-none ${isRedAlarm ? 'text-red-300' : 'text-slate-800'}`}>{data.total}</span>
              <span className="text-[10px] print:text-[8px] block opacity-70 uppercase font-bold mt-1">Katılımcı</span>
            </div>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-3 print:grid-cols-3 gap-5 print:gap-3 shrink-0 avoid-break">
            <div className={`p-5 print:p-3 rounded-2xl border shadow-sm flex flex-col justify-center print:bg-white print:border-slate-300 ${isRedAlarm ? 'border-red-200' : 'border-slate-200'}`}>
              <div className="flex items-center mb-1.5">
                 <AlertTriangle className={`h-6 w-6 print:h-4 print:w-4 mr-2 ${isRedAlarm ? 'text-red-500' : 'text-emerald-500'}`}/>
                 <span className={`text-sm print:text-[10px] font-black uppercase tracking-widest ${isRedAlarm ? 'text-red-600' : 'text-emerald-600'}`}>Kopuş Riski Grubu</span>
              </div>
              <p className={`text-2xl print:text-lg font-black mt-1 ${isRedAlarm ? 'text-red-700' : 'text-emerald-700'}`}>
                 {data.redAlarmStudents} <span className="text-xs print:text-[9px] font-medium opacity-70 text-slate-600 uppercase">Öğrenci (%{redAlarmPercent})</span>
              </p>
            </div>
            <div className="bg-indigo-50 p-5 print:p-3 rounded-2xl border border-indigo-100 print:bg-white print:border-slate-300 shadow-sm flex flex-col justify-center">
              <div className="flex items-center mb-1.5">
                 <Target className="h-6 w-6 print:h-4 print:w-4 mr-2 text-indigo-600"/>
                 <span className="text-sm print:text-[10px] font-black text-indigo-600 uppercase tracking-widest">Baskın Devamsızlık Tipi</span>
              </div>
              <p className="text-base print:text-[12px] font-black text-indigo-900 mt-1 leading-tight truncate">
                {data.chronicPercent > data.acutePercent ? 'Kronikleşme (Soğuma)' : 'Durumsal/Akut Kriz'}
              </p>
            </div>
            <div className="bg-amber-50 p-5 print:p-3 rounded-2xl border border-amber-100 print:bg-white print:border-slate-300 shadow-sm flex flex-col justify-center">
              <div className="flex items-center mb-1.5">
                 <Activity className="h-6 w-6 print:h-4 print:w-4 mr-2 text-amber-600"/>
                 <span className="text-sm print:text-[10px] font-black text-amber-600 uppercase tracking-widest">Ortalama Risk Yükü</span>
              </div>
              <p className="text-2xl print:text-lg font-black text-amber-900 mt-1">
                 {data.avgRisksPerStudent} <span className="text-xs print:text-[9px] font-medium opacity-70 text-slate-600 uppercase">Neden/Kişi</span>
              </p>
            </div>
          </div>

         {/* 3. MASONRY GRID (GİYOTİN HATASI İÇİN YENİDEN TASARLANDI) */}
          <div className="grid grid-cols-2 gap-5 print:gap-3 shrink-0 mt-1 print:mt-0">
            
            {/* KART 1: KARE - KOPUŞ RİSKİ YÜKSEK KADEMELER */}
            <div className="col-span-1 bg-blue-50 p-5 print:p-3.5 rounded-2xl border border-blue-100 print:bg-white print:border-slate-300 flex flex-col justify-center shadow-sm print:shadow-none print:min-h-[90px] avoid-break">
               <h3 className="font-bold text-blue-900 mb-3 print:mb-2 flex items-center text-xs print:text-[10px] uppercase tracking-widest border-b border-blue-200 print:border-slate-200 pb-1.5">
                 <Users className="h-5 w-5 print:h-3.5 print:w-3.5 mr-2 text-blue-600"/> Kopuş Riski Yüksek Kademeler
               </h3>
               <div className="space-y-2 print:space-y-1 mt-1">
                 <div>
                    <span className="text-[10px] print:text-[8px] font-bold text-blue-500 uppercase tracking-widest block mb-0.5">1. Öncelikli Grup</span>
                    <p className="text-sm print:text-[10px] font-black text-slate-800 leading-tight truncate">
                      {data.classStats[0] ? data.classStats[0].name : 'Belirsiz'}
                      {data.classStats[0] && <span className="text-[10px] print:text-[8px] font-bold text-red-600 ml-1">({data.classStats[0].riskScore} Neden/Kişi)</span>}
                    </p>
                 </div>
                 <div>
                    <span className="text-[10px] print:text-[8px] font-bold text-slate-500 uppercase tracking-widest block mb-0.5">2. Öncelikli Grup</span>
                    <p className="text-xs print:text-[9px] font-black text-slate-700 leading-tight truncate">
                      {data.classStats[1] ? data.classStats[1].name : 'Diğer Gruplar Normal'}
                      {data.classStats[1] && <span className="text-[10px] print:text-[8px] font-bold text-red-500 ml-1">({data.classStats[1].riskScore} Neden/Kişi)</span>}
                    </p>
                 </div>
               </div>
            </div>

            {/* KART 2: KARE - DERİNLİK GÖSTERGESİ */}
            <div className="col-span-1 bg-purple-50 p-5 print:p-3.5 rounded-2xl border border-purple-100 print:bg-white print:border-slate-300 flex flex-col justify-center shadow-sm print:shadow-none print:min-h-[90px] avoid-break">
               <h3 className="font-bold text-purple-900 mb-3 print:mb-2 flex items-center text-xs print:text-[10px] uppercase tracking-widest border-b border-purple-200 print:border-slate-200 pb-1.5">
                 <Thermometer className="h-5 w-5 print:h-3.5 print:w-3.5 mr-2 text-purple-600"/> Derinlik Göstergesi
               </h3>
               <div className="flex items-center justify-between mb-1.5 mt-1">
                   <div className="text-center w-14 print:w-12">
                       <span className="block text-[10px] print:text-[7.5px] font-bold text-slate-500 leading-tight mb-0.5">KRONİK</span>
                       <span className="text-base print:text-[11px] font-black text-rose-700">%{data.chronicPercent}</span>
                   </div>
                   <div className="flex-1 px-3 print:px-2 flex items-center">
                       <div className="h-2.5 print:h-1.5 flex-1 bg-rose-500 rounded-l-full print:bg-slate-700"></div>
                       <div className="h-2.5 print:h-1.5 flex-1 bg-amber-400 rounded-r-full print:bg-slate-300"></div>
                   </div>
                   <div className="text-center w-14 print:w-12">
                       <span className="block text-[10px] print:text-[7.5px] font-bold text-slate-500 leading-tight mb-0.5">AKUT</span>
                       <span className="text-base print:text-[11px] font-black text-amber-700">%{data.acutePercent}</span>
                   </div>
               </div>
               <p className="text-[10px] print:text-[8px] text-slate-700 leading-snug font-medium mt-1 text-justify line-clamp-3">
                 {chronicityText}
               </p>
            </div>

            {/* KART 3: YATAY - EN SIK İŞARETLENEN İLK 10 NEDEN */}
            <div className="col-span-2 bg-amber-50 p-4 print:p-3.5 rounded-2xl border border-amber-100 print:bg-white print:border-slate-300 shadow-sm print:shadow-none flex flex-col justify-center avoid-break">
               <div className="flex justify-between items-center border-b border-amber-200 print:border-slate-200 pb-2 mb-2">
                 <h3 className="font-bold text-amber-900 flex items-center text-xs print:text-[10px] uppercase tracking-widest">
                   <AlertTriangle className="h-5 w-5 print:h-3.5 print:w-3.5 mr-2 text-amber-600"/> Nokta Atışı: En Sık Görülen 10 Neden
                 </h3>
                 <span className="text-[10px] print:text-[8px] text-amber-700 print:text-slate-500 italic">Öğrenci Katılım Oranı</span>
               </div>
               
               <div className="grid grid-cols-1 md:grid-cols-2 print:grid-cols-2 gap-x-6 gap-y-2 print:gap-x-4 print:gap-y-1 mt-1">
                 {data.top10Items.length > 0 ? data.top10Items.map((item, idx) => (
                   <div key={idx} className="flex justify-between items-center bg-white print:bg-amber-50/30 px-3 py-2 print:px-2 print:py-1 rounded-lg border border-amber-100 print:border-amber-200 shadow-sm print:shadow-none">
                     <div className="flex items-center flex-1 overflow-hidden pr-3 print:pr-1">
                        <span className="text-amber-500 mr-2 font-black text-xs print:text-[9px]">{(idx + 1)}.</span> 
                        <span className="text-[11px] print:text-[8.5px] font-bold text-slate-800 leading-tight truncate" title={item.text}>{item.text}</span>
                     </div>
                     <span className="text-xs print:text-[9px] font-black text-amber-600 shrink-0">%{item.percent}</span>
                   </div>
                 )) : (
                   <p className="text-xs text-slate-500 italic col-span-2 text-center">Yeterli veri yok.</p>
                 )}
               </div>
            </div>

            {/* KART 4: YATAY - DEVAMSIZLIK ALT BOYUT DAĞILIMI */}
            <div className="col-span-2 bg-slate-50 p-5 print:p-3.5 rounded-2xl border border-slate-200 print:bg-white print:border-slate-300 shadow-sm print:shadow-none avoid-break">
               <div className="flex justify-between items-center border-b border-slate-200 print:border-slate-200 pb-2 mb-2">
                 <h3 className="font-bold text-slate-800 flex items-center text-xs print:text-[10px] uppercase tracking-widest">
                   <PieChartIcon className="h-5 w-5 print:h-3.5 print:w-3.5 mr-2 text-slate-600"/> Devamsızlık Alt Boyut Dağılımı
                 </h3>
                 <span className="text-[10px] print:text-[8px] text-slate-500 italic">Genel Risk Yüzdesi</span>
               </div>
               
               <div className="space-y-3 print:space-y-2 mt-2">
                  {data.topCategories.slice(0, 4).map((dim, idx) => (
                    <div key={idx}>
                      <div className="flex justify-between items-end mb-1 print:mb-0.5">
                        <span className="text-xs print:text-[9px] font-bold text-slate-700">{dim.name}</span>
                        <span className="text-xs print:text-[9px] font-black text-slate-900">%{dim.percent} <span className="text-[10px] print:text-[7.5px] text-slate-500 font-medium">({dim.count} Madde)</span></span>
                      </div>
                      <div className="h-2 print:h-1.5 w-full bg-slate-200 print:bg-slate-100 rounded-full overflow-hidden print:border print:border-slate-200">
                        <div className="h-full rounded-full bg-slate-600 print:bg-slate-500" style={{ width: `${dim.percent}%` }}></div>
                      </div>
                    </div>
                  ))}
               </div>
            </div>
         
          </div>

          <div className="grid grid-cols-2 gap-5 print:gap-3 shrink-0 avoid-break mt-1 print:mt-0">
             
             <div className={`col-span-1 p-5 print:p-4 rounded-2xl border flex flex-col shadow-sm print:shadow-none print:min-h-[140px] ${interventionObj.bg}`}>
                <h3 className="font-bold text-slate-800 mb-2 print:mb-2 flex items-center text-xs print:text-[10px] uppercase tracking-widest border-b border-slate-200 print:border-slate-200 pb-2">
                  <interventionObj.icon className={`h-5 w-5 print:h-4 print:w-4 mr-2 ${interventionObj.color}`}/>
                  Kurumsal Müdahale Odağı
                </h3>
                <div className="flex-1 flex flex-col justify-start mt-1">
                  <p className={`text-sm print:text-[11px] font-black leading-tight mb-1.5 ${interventionObj.color}`}>
                      {interventionObj.title}
                  </p>
                  <p className="text-[11px] print:text-[9px] text-slate-600 leading-snug mb-2.5">
                      {interventionObj.desc}
                  </p>
                  <ul className="space-y-1.5 print:space-y-1.5 mt-auto">
                    {interventionObj.bullets.map((b, i) => (
                      <li key={i} className="flex items-start text-[11px] print:text-[8.5px] text-slate-800 font-medium leading-snug">
                        <span className={`mr-1.5 font-black ${interventionObj.color}`}>•</span> {b}
                      </li>
                    ))}
                  </ul>
                </div>
             </div>

             <div className={`col-span-1 p-5 print:p-4 rounded-2xl border flex flex-col shadow-sm print:shadow-none print:min-h-[140px] ${stakeholderObj.bg}`}>
                <h3 className="font-bold text-slate-800 mb-2 print:mb-2 flex items-center text-xs print:text-[10px] uppercase tracking-widest border-b border-slate-200 print:border-slate-200 pb-2">
                  <stakeholderObj.icon className={`h-5 w-5 print:h-4 print:w-4 mr-2 ${stakeholderObj.color}`}/>
                  Paydaş Eylem Planı
                </h3>
                <div className="flex-1 flex flex-col justify-start mt-1">
                  <p className={`text-sm print:text-[11px] font-black leading-tight mb-1.5 ${stakeholderObj.color}`}>
                      {stakeholderObj.title}
                  </p>
                  <p className="text-[11px] print:text-[9px] text-slate-600 leading-snug mb-2.5">
                      {stakeholderObj.desc}
                  </p>
                  <ul className="space-y-1.5 print:space-y-1.5 mt-auto">
                    {stakeholderObj.bullets.map((b, i) => (
                      <li key={i} className="flex items-start text-[11px] print:text-[8.5px] text-slate-800 font-medium leading-snug">
                        <span className={`mr-1.5 font-black ${stakeholderObj.color}`}>•</span> {b}
                      </li>
                    ))}
                  </ul>
                </div>
             </div>

          </div>

        </div>
        {/* ==================== 1. SAYFA SONU ==================== */}

        <div className="hidden print:block" style={{ pageBreakBefore: 'always' }}></div>

        {/* ========================================================= */}
        {/* SAYFA 2: YAPAY ZEKA RAPORU VE İMZALAR                    */}
        {/* ========================================================= */}
        <div className="flex flex-col mt-4 print:mt-0">
          
          <div className="bg-purple-50 p-6 print:p-0 rounded-3xl print:rounded-none border border-purple-100 print:border-none shadow-sm print:shadow-none flex flex-col pt-2 print:pt-4">
            <div className="flex justify-between items-center mb-4 print:mb-3 border-b border-purple-200 print:border-slate-300 pb-3 print:pb-3 shrink-0">
              <h3 className="font-bold text-purple-900 flex items-center text-base print:hidden uppercase tracking-widest">
                <Sparkles className="h-5 w-5 mr-2 text-purple-600"/> Yapay Zeka Kurumsal Strateji Raporu
              </h3>
              <h3 className="hidden print:flex items-center font-bold text-slate-900 text-sm uppercase tracking-widest w-full">
                <Brain className="h-5 w-5 mr-2"/> Kurumsal Okula Bağlanma Planı
              </h3>
              <button onClick={() => onGenerateAI(title, data.topCategories)} disabled={aiLoading} className="px-5 py-2.5 bg-purple-600 text-white rounded-xl font-bold text-xs hover:bg-purple-700 transition shadow-sm print:hidden flex items-center">
                {aiLoading ? <Loader2 className="animate-spin h-4 w-4 mr-2"/> : <Brain className="h-4 w-4 mr-2"/>}
                {aiLoading ? "Analiz Ediliyor..." : "Raporu Oluştur"}
              </button>
            </div>
            {aiResult && (
            <div className="bg-white p-6 rounded-xl text-slate-800 border border-purple-100 print:border-0 print:p-0 print:text-black mt-4">
                <EditableAIBox text={aiResult} />
            </div>
        )}
          </div>

         {/* YAZDIRMA İÇİN İMZA ALANI (Giyotin Hatası Giderildi) */}
          <div className="hidden print:flex justify-between mt-8 pt-6 text-[12px] text-black px-12 border-t border-slate-300 avoid-break print:break-inside-avoid">
              <div className="text-center">
                  <p className="font-bold">Okul Psikolojik Danışmanı</p>
                  <p className="mt-12">İmza</p>
              </div>
              <div className="text-center">
                  <p className="font-bold">Okul Müdürü</p>
                  <p className="mt-12">İmza</p>
              </div>
          </div>
          
        </div>
      </div>
    </>
  );
};